import React from 'react';
import { Checkbox, Form, Row } from 'antd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import UsersList from 'components/UsersList';
import TypeReceiverSelect from './TypeReceiverSelect';

export type TypeRoleSelectProps = {
  label?: string;
  fromWF?: boolean;
  lg?: number;
};

const TypeRoleSelect = ({ lg, label, fromWF }: TypeRoleSelectProps) => {
  let parcode = '';
  switch (label) {
    case 'usereq':
      parcode = 'RATREQTYPE';
      break;
    case 'durationreq':
      parcode = 'DURREQTYPE';
      break;
    case 'firstrentalreq':
      parcode = 'FSTREQTYPE';
      break;
    case 'ratereq':
      parcode = 'RATREQTYPE';
      break;
      case 'marginratereq':
        parcode = 'RATREQTYPE';
        break;
    case 'request':
      parcode = 'RATREQTYPE';
      break;
    case 'rvreq':
      parcode = 'RVREQTYPE';
      break;
    case 'upfrontreq':
      parcode = 'UPREQTYPE';
      break;
    case 'servreq':
      parcode = 'SERREQTYPE';
      break;
    case 'checkrequest':
      parcode = 'CHKREQTYPE';
      break;
  }
  return (
    <>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue, setFieldsValue }) => (
          <FormInput
            col
            xs={24}
            lg={lg ?? 8}
            name={`${label}type`}
            rules={[{ required: true, message: ' Request Type is required' }]}
          >
            <ParListSelect
              parcode={parcode}
              onChange={() => {
                setFieldsValue({
                  [`${label}receivertype`]: null,
                  receivertype: null,
                });
              }}
            />
          </FormInput>
        )}
      </Form.Item>

      <Form.Item noStyle shouldUpdate={shouldUpdateCompare(`${label}type`)}>
        {({ getFieldValue, setFieldsValue }) => {
          if (getFieldValue(`${label}type`) !== 'INFO')
            return (
              <>
                {!fromWF && (
                  <FormInput
                    col
                    xs={24}
                    lg={lg??8}
                    name={`${label}receivertype`}
                    rules={[
                      {
                        required: true,
                        message: 'Request Receiver Type is required',
                      },
                    ]}
                  >
                    <ParListSelect
                      parcode="RECEIVTYPE"
                      onChange={() => {
                        setFieldsValue({
                          [`${label}receiverroleprofile`]: null,
                          [`${label}receiverid`]: null,
                        });
                      }}
                    />
                  </FormInput>
                )}
                <Form.Item
                  noStyle
                  shouldUpdate={shouldUpdateCompare([
                    `${label}receivertype`,
                    `${label}type`,
                  ])}
                >
                  {({ getFieldValue, setFieldsValue }) => {
                    const receiverType = getFieldValue(`${label}receivertype`);
                    const type = getFieldValue(`${label}type`);
                    if (type === 'OVERRIDE' && fromWF) {
                      return (
                        <Row>
                          <FormInput
                            col
                            xs={24}
                            lg={lg ?? 8}
                            name="notifoverridestatus"
                            valuePropName="checked"
                          >
                            <Checkbox />
                          </FormInput>

                          <TypeReceiverSelect label="notifoverride" />
                        </Row>
                      );
                    } else {
                      if (type === 'REQVAL' && fromWF) {
                        return (
                          <>
                            <Row gutter={16}>
                              <FormInput
                                col
                                xs={24}
                                lg={lg ?? 8}
                                name="receivertype"
                              >
                                <ParListSelect
                                  parcode="RECEIVTYPE"
                                  onChange={() => {
                                    setFieldsValue({
                                      receiverroleprofile: null,
                                      receiverid: null,
                                    });
                                  }}
                                />
                              </FormInput>
                              <Form.Item
                                noStyle
                                shouldUpdate={shouldUpdateCompare(
                                  'receivertype'
                                )}
                              >
                                {({ getFieldValue }) => {
                                  if (
                                    getFieldValue('receivertype') ===
                                      'UPROFILE' ||
                                    getFieldValue('receivertype') === 'UROLE' ||
                                    getFieldValue('receivertype') === 'USERJOB'
                                  ) {
                                    return (
                                      <FormInput
                                        col
                                        xs={24}
                                        lg={lg ?? 8}
                                        name="receiverroleprofile"
                                      >
                                        <ParListSelect
                                          parcode={
                                            getFieldValue('receivertype') ===
                                            'UPROFILE'
                                              ? 'USERJOB'
                                              : getFieldValue('receivertype')
                                          }
                                        />
                                      </FormInput>
                                    );
                                  } else if (
                                    getFieldValue('receivertype') !==
                                      'SENDER' &&
                                      getFieldValue('receivertype') !==
                                      'USERCREATE' &&
                                      getFieldValue('receivertype') !==
                                      'USERUPDATE' &&
                                   
                                      getFieldValue('receivertype') !== 'ME'
                                  ) {
                                    getFieldValue('receiverid') === 0 &&
                                      setFieldsValue({
                                        receiverid: '',
                                      });
                                    return (
                                      <FormInput
                                        col
                                        xs={24}
                                        lg={lg ?? 8}
                                        name="receiverid"
                                        rules={[{ required: true }]}
                                      >
                                        <UsersList />
                                      </FormInput>
                                    );
                                  }
                                }}
                              </Form.Item>
                            </Row>
                            <Row gutter={16}>
                              <FormInput
                                col
                                xs={24}
                                lg={lg ?? 8}
                                name="notifdecisionstatus"
                                valuePropName="checked"
                              >
                                <Checkbox />
                              </FormInput>

                              <TypeReceiverSelect label="notifdecision" />
                            </Row>
                          </>
                        );
                      } else if (!receiverType) {
                        return null;
                      } else if (
                        receiverType === 'UPROFILE' ||
                        receiverType === 'UROLE' ||
                        receiverType === 'USERJOB'
                      ) {
                        return (
                          <FormInput
                            col
                            xs={6}
                            md={lg ?? 8}
                            name={`${label}receiverroleprofile`}
                            rules={[{ required: true }]}
                          >
                            <ParListSelect
                              parcode={
                                receiverType === 'UPROFILE'
                                  ? 'USERJOB'
                                  : receiverType
                              }
                            />
                          </FormInput>
                        );
                      } else if (
                        receiverType !== 'SENDER' &&
                        receiverType !== 'USERCREATE' &&
                        receiverType !== 'USERUPDATE' &&
                        receiverType !== 'ME'
                      ) {
                         getFieldValue(`${label}receiverid`) === 0 &&
                          setFieldsValue({ [`${label}receiverid`]: '' });
                        return (
                          <FormInput
                            col
                            xs={4}
                            lg={lg ?? 8}
                            name={`${label}receiverid`}
                            rules={getFieldValue(`${label}type`).trim()==='' ? [{required: false,}] :[{ required: true }]}
                          >
                            <UsersList />
                          </FormInput>
                        );
                      }
                    }
                  }}
                </Form.Item>
              </>
            );
        }}
      </Form.Item>
    </>
  );
};

export default TypeRoleSelect;
